
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Play, Users, Folder, Settings } from 'lucide-react';

const MobileNavbar = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-youtube-dark border-t border-gray-200 dark:border-gray-800 py-2 px-4 flex justify-around items-center z-50 mobile-safe-bottom">
      <Link 
        to="/" 
        className="flex flex-col items-center justify-center text-xs"
      >
        <Home className={`w-6 h-6 ${isActive('/') ? 'text-youtube-red' : 'text-gray-600 dark:text-gray-400'}`} />
        <span className={isActive('/') ? 'text-youtube-red font-medium' : 'text-gray-600 dark:text-gray-400'}>Accueil</span>
      </Link>
      
      <Link 
        to="/feed" 
        className="flex flex-col items-center justify-center text-xs"
      >
        <Play className={`w-6 h-6 ${isActive('/feed') ? 'text-youtube-red' : 'text-gray-600 dark:text-gray-400'}`} />
        <span className={isActive('/feed') ? 'text-youtube-red font-medium' : 'text-gray-600 dark:text-gray-400'}>Flux</span>
      </Link>
      
      <Link 
        to="/creators" 
        className="flex flex-col items-center justify-center text-xs"
      >
        <Users className={`w-6 h-6 ${isActive('/creators') ? 'text-youtube-red' : 'text-gray-600 dark:text-gray-400'}`} />
        <span className={isActive('/creators') ? 'text-youtube-red font-medium' : 'text-gray-600 dark:text-gray-400'}>Créateurs</span>
      </Link>
      
      <Link 
        to="/playlists" 
        className="flex flex-col items-center justify-center text-xs"
      >
        <Folder className={`w-6 h-6 ${isActive('/playlists') ? 'text-youtube-red' : 'text-gray-600 dark:text-gray-400'}`} />
        <span className={isActive('/playlists') ? 'text-youtube-red font-medium' : 'text-gray-600 dark:text-gray-400'}>Collections</span>
      </Link>
      
      <Link 
        to="/settings" 
        className="flex flex-col items-center justify-center text-xs"
      >
        <Settings className={`w-6 h-6 ${isActive('/settings') ? 'text-youtube-red' : 'text-gray-600 dark:text-gray-400'}`} />
        <span className={isActive('/settings') ? 'text-youtube-red font-medium' : 'text-gray-600 dark:text-gray-400'}>API Key</span>
      </Link>
    </div>
  );
};

export default MobileNavbar;
